/**
 * The phase of a day - morning, afternoon, or evening.
 */
export type PhaseOfDay = 'Morning' | 'Afternoon' | 'Evening'

/**
 * Computes the phase of the day given the date.
 */
export function computePhaseOfDay(date: Date): PhaseOfDay {
  const hours = date.getHours()

  if (hours >= 0 && hours < 12) {
    return 'Morning'
  } else if (hours >= 12 && hours < 18) {
    return 'Afternoon'
  } else {
    return 'Evening'
  }
}
